import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdminRoutingModule } from './admin-routing.module';
import { UserManagementModule } from './user-management/user-management.module';
import { ContentManagementModule } from './content-management/content-management.module';
import { SalePointManagementModule } from './sale-point-management/sale-point-management.module';
import { AgmCoreModule } from '@agm/core';
import { AgmDrawingModule } from '@agm/drawing';
import { environment } from 'src/environments/environment';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    AdminRoutingModule,
    UserManagementModule,
    ContentManagementModule,
    SalePointManagementModule,
    AgmCoreModule.forRoot({
      apiKey: environment.MAPS_API_KEY,
      libraries: ['places', 'drawing', 'geometry']
    }),
    AgmDrawingModule,
  ]
})
export class AdminModule { }
